import "@fortawesome/fontawesome-free/css/all.css";
import "./app/WorkspaceExtension";

import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { Extensions } from "@somewear/model";
import { indexCss, MuiTheme, SomewearTheme } from "@somewear/ui";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import { router } from "./app/router";
import store from "./app/store";
import Loader from "./common/Loader";
import * as serviceWorker from "./serviceWorker";

if (import.meta.env.PROD) {
	console.log = () => {};
	console.log("this should be muted");
	console.time = () => {};
	console.timeEnd = () => {};
}

//Need to do this to actually load the extensions
// eslint-disable-next-line
const extensions = Extensions;

// reference css modules
indexCss();

const container = document.getElementById("root")!;

const root = createRoot(container);

root.render(
	<Provider store={store}>
		<MuiThemeProvider theme={MuiTheme}>
			<ThemeProvider theme={SomewearTheme}>
				<RouterProvider
					router={router}
					future={{ v7_startTransition: true }}
					fallbackElement={<Loader fullScreen={true} />}
				/>
			</ThemeProvider>
		</MuiThemeProvider>
	</Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
